import axios from "axios";
import Config from "../Config";

class GuestRequests{
  static baseUrl = `${Config.backendDomain}`;

  async getCategories(){
    const response = await axios.get(`${GuestRequests.baseUrl}categories`);
    return response.data;
  }

  async getSubscriptionPlans(){
    const response = await axios.get(`${GuestRequests.baseUrl}subscription/plans`);
    return response.data;
  }
}
const instance = new GuestRequests();
Object.freeze(instance);

export default instance;
